import { useStyletron } from "@mezo-org/mezo-clay"

import GridContainer from "#/shared/components/GridContainer"

import DepositForm from "./DepositForm"

export default function DepositFormContainer() {
  const [css, theme] = useStyletron()

  return (
    <GridContainer
      className={css({ background: theme.colors.backgroundSecondary })}
      minH="calc(100vh - 257px)"
      pt={10}
      px={0}
      position="relative"
    >
      <DepositForm />
    </GridContainer>
  )
}
